import './styles/index.sass';
import { BrowserRouter } from 'react-router-dom';
import Applayout from "./components/Applayout"
import { AuthProvider } from "./AuthContext";

function App() {

  return (
    <div className="App">
      <header className="App-header">

      </header>
      <AuthProvider>
        <BrowserRouter>
          <Applayout />
        </BrowserRouter>
      </AuthProvider>

    </div>
  );
}

export default App;